var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"shop-cart-sticky"},[_c('shop-cart',{ref:"shopCart",attrs:{"selectFoods":_vm.selectFoods,"deliveryPrice":_vm.deliveryPrice,"minPrice":_vm.minPrice,"fold":_vm.fold,"sticky":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }